import { render, staticRenderFns } from "./VideoPinghu.vue?vue&type=template&id=54eb0b91&scoped=true&"
import script from "./VideoPinghu.vue?vue&type=script&lang=ts&"
export * from "./VideoPinghu.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPinghu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoPinghu.vue?vue&type=style&index=1&id=54eb0b91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb0b91",
  null
  
)

export default component.exports